document.addEventListener('DOMContentLoaded', function () {
  const isTouchDevice =
    window.matchMedia('(max-width: 989px)').matches ||
    window.matchMedia('(pointer: coarse)').matches ||
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0;

  if (!isTouchDevice) return;

  const lightbox = document.querySelector('[data-mobile-product-lightbox]');
  const track = document.querySelector('[data-mobile-product-lightbox-track]');

  if (!lightbox || !track) return;

  const getButtons = () => Array.from(document.querySelectorAll('.mobile-product-lightbox-trigger'));

  const buildSlides = () => {
    const buttons = getButtons();

    track.innerHTML = '';

    buttons.forEach((button) => {
      const slide = document.createElement('div');
      slide.className = 'mobile-product-lightbox__slide';

      const image = document.createElement('img');
      image.src = button.getAttribute('data-mobile-lightbox-src') || '';
      image.alt = button.getAttribute('data-mobile-lightbox-alt') || '';
      image.loading = 'lazy';

      slide.appendChild(image);
      track.appendChild(slide);
    });

    return buttons;
  };

  const openLightbox = (index) => {
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mobile-product-lightbox-open');

    setTimeout(() => {
      track.scrollLeft = track.clientWidth * index;
    }, 50);
  };

  const closeLightbox = () => {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mobile-product-lightbox-open');
    track.scrollLeft = 0;
  };

  lightbox.querySelectorAll('[data-mobile-product-lightbox-close]').forEach((element) => {
    element.addEventListener('click', closeLightbox);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && lightbox.classList.contains('is-open')) {
      closeLightbox();
    }
  });

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('.mobile-product-lightbox-trigger');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const buttons = buildSlides();
      const index = buttons.indexOf(button);

      openLightbox(index < 0 ? 0 : index);
    },
    true
  );
});